import React from "react";
import { Button } from "../../../ui/button";
export { Button };
export { Input } from "../../../ui/input";
export { Textarea } from "../../../ui/textarea";
export { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../../../ui/dialog";

const BASE = process.env.REACT_APP_BACKEND_URL;
export async function registryApi(path, options = {}) {
  const response = await fetch(`${BASE}/api${path}`, { credentials: "include", ...options, headers: { "Content-Type": "application/json", ...options.headers } });
  const data = await response.json();
  if (!response.ok) throw new Error(typeof data.detail === "string" ? data.detail : "Unable to complete request");
  return data;
}
export const money = value => value == null ? "Not recorded" : new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2, maximumFractionDigits: 5 }).format(value);
export const date = value => value ? new Date(value).toLocaleString() : "Not yet";
export const Pill = ({ value, id }) => <span data-testid={id} className={`registry-pill registry-pill-${value}`}>{String(value || "unknown").replaceAll("_", " ")}</span>;
export const Metric = ({ label, value, note, id }) => <div className="registry-metric"><span>{label}</span><strong data-testid={id}>{value}</strong>{note && <small>{note}</small>}</div>;
export const ErrorNotice = ({ error, id = "registry-error" }) => error ? <p role="alert" className="registry-error" data-testid={id}>{error}</p> : null;
export const Empty = ({ children, id }) => <div data-testid={id} className="registry-empty">{children}</div>;